(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setHeaderHeightLive();

      window.addEventListener('resizeend', this.setHeaderHeight.bind(this));
      window.addEventListener('resizeend', this.setHeaderHeightLive.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => { this.preventHide = false; });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderHeightLive(event, zero) {
      document.documentElement.style.setProperty('--header-height-live', `${zero ? 0 : this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["withdrawal-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-withdrawal]').forEach(function (root) {
    var PAYLOAD_KEY = 'withdrawal_payload';
    var form = root.querySelector('form');

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function ackRows(payload, labels) {
      var order = ['name', 'email', 'order', 'date', 'items', 'reason'];
      var rows = [];
      order.forEach(function (key) {
        var value = payload.values ? payload.values[key] : '';
        if (!value) return;
        rows.push([labels.fields[key] || key, value]);
      });
      return rows;
    }

    function buildAckDoc(payload, labels) {
      var when = new Date(payload.submittedOn || Date.now()).toLocaleString();
      var rows = ackRows(payload, labels).map(function (row) {
        return '<tr><th style="text-align:left;padding:4px 12px 4px 0;vertical-align:top">' +
          escapeHtml(row[0]) + '</th><td style="padding:4px 0">' + escapeHtml(row[1]) + '</td></tr>';
      }).join('');
      return '<!doctype html><html><head><meta charset="utf-8"><title>' +
        escapeHtml(labels.ackHeading) + '</title></head><body style="font-family:sans-serif;max-width:640px;margin:24px auto;color:#111">' +
        '<h1 style="font-size:20px">' + escapeHtml(labels.ackHeading) + '</h1>' +
        '<p>' + escapeHtml(labels.shop) + '</p>' +
        '<p>' + escapeHtml(labels.ackIntro) + '</p>' +
        '<p><strong>' + escapeHtml(labels.reference) + '</strong> ' + escapeHtml(payload.reference) + '<br>' +
        '<strong>' + escapeHtml(labels.submittedOn) + '</strong> ' + escapeHtml(when) + '</p>' +
        '<table style="border-collapse:collapse">' + rows + '</table>' +
        '</body></html>';
    }

    var successEl = root.querySelector('[data-withdrawal-success]');
    if (successEl) {
      var raw = sessionStorage.getItem(PAYLOAD_KEY);
      if (raw) {
        var payload, labels;
        try { payload = JSON.parse(raw); } catch (e) { payload = null; }
        var labelsEl = root.querySelector('[data-withdrawal-labels]');
        try { labels = labelsEl ? JSON.parse(labelsEl.textContent) : null; } catch (e) { labels = null; }

        if (payload && labels) {
          var refLine = root.querySelector('[data-withdrawal-reference]');
          var refValue = root.querySelector('[data-withdrawal-reference-value]');
          if (refLine && refValue && payload.reference) {
            refValue.textContent = payload.reference;
            refLine.hidden = false;
          }

          var ackEl = root.querySelector('[data-withdrawal-ack]');
          if (ackEl) {
            var dl = '<p>' + escapeHtml(labels.ackIntro) + '</p><dl class="withdrawal__review">';
            ackRows(payload, labels).forEach(function (row) {
              dl += '<div><dt>' + escapeHtml(row[0]) + '</dt><dd>' + escapeHtml(row[1]) + '</dd></div>';
            });
            dl += '</dl>';
            ackEl.innerHTML = dl;
            ackEl.hidden = false;
          }

          var actionsEl = root.querySelector('[data-withdrawal-ack-actions]');
          if (actionsEl) actionsEl.hidden = false;

          var doc = buildAckDoc(payload, labels);

          var downloadBtn = root.querySelector('[data-withdrawal-download]');
          if (downloadBtn) {
            downloadBtn.addEventListener('click', function () {
              var blob = new Blob([doc], { type: 'text/html' });
              var url = URL.createObjectURL(blob);
              var a = document.createElement('a');
              a.href = url;
              a.download = 'withdrawal-acknowledgement-' + (payload.reference || 'request') + '.html';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(url);
            });
          }

          var printBtn = root.querySelector('[data-withdrawal-print]');
          if (printBtn) {
            printBtn.addEventListener('click', function () {
              var w = window.open('', '_blank');
              if (!w) { window.print(); return; }
              w.document.write(doc);
              w.document.close();
              w.focus();
              w.print();
            });
          }
        }
        sessionStorage.removeItem(PAYLOAD_KEY);
      }
      return;
    }

    if (!form) return;

    var step1 = form.querySelector('[data-withdrawal-step="1"]');
    var step2 = form.querySelector('[data-withdrawal-step="2"]');
    var nextBtn = form.querySelector('[data-withdrawal-next]');
    var backBtn = form.querySelector('[data-withdrawal-back]');
    var submitBtn = form.querySelector('[data-withdrawal-submit]');
    var confirmBox = form.querySelector('[data-withdrawal-confirm]');
    var reviewEl = form.querySelector('[data-withdrawal-review]');
    var refField = form.querySelector('[data-withdrawal-ref-field]');

    function buildReference() {
      var now = new Date();
      var stamp = now.getFullYear().toString() +
        ('0' + (now.getMonth() + 1)).slice(-2) +
        ('0' + now.getDate()).slice(-2);
      var rand = Math.random().toString(36).slice(2, 7).toUpperCase();
      return 'WD-' + stamp + '-' + rand;
    }

    function renderReview() {
      reviewEl.textContent = '';
      var fields = step1.querySelectorAll('input, textarea');
      fields.forEach(function (field) {
        if (field.type === 'hidden' || !field.value) return;
        var labelEl = step1.querySelector('label[for="' + field.id + '"]');
        var row = document.createElement('div');
        var dt = document.createElement('dt');
        var dd = document.createElement('dd');
        dt.textContent = labelEl ? labelEl.textContent : field.name;
        dd.textContent = field.value;
        row.appendChild(dt);
        row.appendChild(dd);
        reviewEl.appendChild(row);
      });
    }

    nextBtn.addEventListener('click', function () {
      var required = step1.querySelectorAll('[required]');
      var valid = true;
      required.forEach(function (field) {
        if (!field.reportValidity()) valid = false;
      });
      if (!valid) return;
      renderReview();
      step1.hidden = true;
      step2.hidden = false;
      step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    backBtn.addEventListener('click', function () {
      step2.hidden = true;
      step1.hidden = false;
    });

    confirmBox.addEventListener('change', function () {
      submitBtn.disabled = !confirmBox.checked;
    });

    function fieldValue(id) {
      var el = form.querySelector('#' + id);
      return el ? el.value : '';
    }

    form.addEventListener('submit', function () {
      var reference = buildReference();
      if (refField) refField.value = reference;
      var payload = {
        reference: reference,
        submittedOn: new Date().toISOString(),
        values: {
          name: fieldValue('WithdrawalName'),
          email: fieldValue('WithdrawalEmail'),
          order: fieldValue('WithdrawalOrder'),
          date: fieldValue('WithdrawalDate'),
          items: fieldValue('WithdrawalItems'),
          reason: fieldValue('WithdrawalReason')
        }
      };
      try { sessionStorage.setItem(PAYLOAD_KEY, JSON.stringify(payload)); } catch (e) {}
    });
  });

  } catch(e) { console.error(e); }
})();
})();
